import { axiosInstanceCached } from '@/utils/axios';
import { handleApiError, deleteDataCache } from '@/utils/helpers';

export const list = async (payload = {}) => {
  let response = {};
  await deleteDataCache(axiosInstanceCached, payload?.deleteCache, 'course_list');

  try {
    // *param ?platform=windows to limit duplicate courses
    response = await axiosInstanceCached.get(`/courses?platform=windows`, {
      id: `course_list`,
      cache: {
        ttl: 1000 * 60 * 240, // 4 hour cache
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const show = async (id) => {
  let response = {};
  try {
    response = await axiosInstanceCached.get(`/courses/${id}`, {
      id: `course_${id}`,
      cache: {
        ttl: 1000 * 60 * 240, // 4 hour cache
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
